module.exports = __webpack_public_path__ + "static/oboe_en-eceedcb85f3223e5fad962b6fb5f6e5d.pdf";